/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import AppContainer from "../../../Components/Structure/AppContainer";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import ReplacementsCountToday from "../../../Components/Statistics/Replacements/ReplacementsCountToday";
import ReplacementsPerSchool from "../../../Components/Statistics/Replacements/ReplacementsPerSchool";
import ReplacementsList from "../../../Components/Statistics/Replacements/ReplacementsList";

function CardReplacementsPage() {
    const [replacementsPerSchool, setReplacementsPerSchool] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [replacementsToday, setReplacementsToday] = useState(false);
    const [allReplacementsCount, setAllReplacementsCount] = useState(false);
    const [replacementsPerSchoolToday, setReplacementsPerSchoolToday] = useState([]);
    

    useEffect(() => {
          if (startDate || endDate) {
              searchTotalReplacementsPerSchool();
          } else {
              getTotalReplacementsPerSchool();
          }
      }, []);

    useEffect(() => {
            getReplacementsToday();
            countAllReplacements();
            getTotalReplacementsPerSchoolToday();
    }, []);

    const getTotalReplacementsPerSchool = async () => {
      setLoading(true);
        const server_response = await ajaxStudent.totalReplacementsPerSchool();
        setLoading(false);
        if (server_response.status === "OK") {
          setReplacementsPerSchool(server_response.details);
        } else {
          setReplacementsPerSchool([]);
        }
    };

    const searchTotalReplacementsPerSchool = async () => {
      setLoading2(true);
        const server_response = await ajaxStudent.searchTotalReplacementsPerSchool(startDate, endDate);
        setLoading2(false);
        if (server_response.status === "OK") {
          setReplacementsPerSchool(server_response.details);
        } else {
          setReplacementsPerSchool([]);
        }
    };

    const getReplacementsToday = async () => {
        const server_response = await ajaxStudent.activationsToday();
        if (server_response.status === "OK") {
          setReplacementsToday(server_response.details);
        } else {
          setReplacementsToday("404");
        }
    };

    const countAllReplacements = async () => {
      const server_response = await ajaxStudent.countAllReplacements();
      if (server_response.status === "OK") {
        setAllReplacementsCount(server_response.details);
      } else {
        setAllReplacementsCount("404");
      }
    };

    const getTotalReplacementsPerSchoolToday = async () => {
      const server_response = await ajaxStudent.totalReplacementsPerSchoolToday();
      if (server_response.status === "OK") {
        setReplacementsPerSchoolToday(server_response.details);
      } else {
        setReplacementsPerSchoolToday("404");
      }
    };

    const setReplacement = (e) => {
      e.preventDefault();
      setStartDate("");
      setEndDate("");
      getTotalReplacementsPerSchool();
      
    };

  return (
    <AppContainer title="Replacements / Swaps">
      <Toaster position="top-center" reverseOrder={false} />
      
      <div className="row">
        <div className="col-lg-4">
          <div className="row">
          <ReplacementsCountToday replacementsPerSchoolToday={replacementsPerSchoolToday} cardReplacementsToday={replacementsToday[11]} wbReplacementsToday={replacementsToday[13]} />
            <ReplacementsPerSchool replacementsPerSchool={replacementsPerSchool} loading={loading} loading2={loading2}
            startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} searchReplacements={searchTotalReplacementsPerSchool}
            resetSearch={setReplacement}/>
          </div> 
        </div>
        
        <div className="col-lg-8">
          <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            {allReplacementsCount? allReplacementsCount.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Total Replacements / Swaps</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ReplacementsList/>
            

          </div>
        </div>

        
      </div>
    </AppContainer>
  );
}

export default CardReplacementsPage;
